import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { Form } from 'react-bootstrap';
import * as paramOps from '../../../api/Tasks/task-param-operations';

const SubtaskTextField = ({ parameter }) => {
  const hasComments = !isEmpty(paramOps.getComments(parameter));

  return (
    <Form.Group controlId={paramOps.getId(parameter)}>
      <Form.Label>{paramOps.getLabel(parameter)}</Form.Label>
      <Form.Control
        as="textarea"
        rows="1"
        name={paramOps.getId(parameter)}
        defaultValue={paramOps.getValue(parameter)}
      />
      {hasComments && (
        <Form.Text className="text-muted">{paramOps.getComments(parameter)}</Form.Text>
      )}
    </Form.Group>
  );
};

SubtaskTextField.propTypes = {
  parameter: PropTypes.object.isRequired
};

export default SubtaskTextField;
